import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // إخفاء Sidebar تلقائياً على الموبايل عند فتح الصفحة
  useEffect(() => {
    if (window.innerWidth <= 768 && isOpen) {
      toggleSidebar();
    }
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      path: '/dashboard',
      icon: '🏠',
      label: 'الرئيسية'
    },
    {
      path: '/reports',
      icon: '📋',
      label: 'التقارير اليومية'
    },
    {
      path: '/pours',
      icon: '🏗️',
      label: 'سجل الصبات'
    },
    {
      path: '/cubes',
      icon: '🧊',
      label: 'المكعبات'
    },
    {
      path: '/inventory',
      icon: '📦',
      label: 'المخزون'
    },
    {
      path: '/personnel',
      icon: '👥',
      label: 'الأفراد'
    }
  ];

  // القائمة الإدارية (للـ Admin فقط)
  const adminMenuItems = [
    {
      path: '/admin/delete',
      icon: '🗑️',
      label: 'حذف البيانات'
    }
  ];

  return (
    <>
      {isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <h2>Metro4</h2>
            <p>نظام إدارة المعامل</p>
          </div>
        </div>

        <div className="user-info">
          <div className="user-avatar">
            {user?.fullName?.charAt(0) || 'A'}
          </div>
          <div className="user-details">
            <h3>{user?.fullName || 'مستخدم'}</h3>
            <p className="user-role">{user?.role || 'موظف'}</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? 'active' : ''}
                  onClick={toggleSidebar}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {user?.role === 'admin' && (
          <div className="admin-section">
            <div className="admin-divider">أدوات الإدارة</div>
            <nav className="admin-nav">
              <ul>
                {adminMenuItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={location.pathname === item.path ? 'active' : ''}
                      onClick={toggleSidebar}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span className="nav-label">{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <span className="nav-icon">🚪</span>
            <span className="nav-label">تسجيل الخروج</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;